export { default } from './ExtraText.js';
